// alliance logo swap
if (basVendor == '182267' || basVendorCookie == '182267') {

	jQuery('<img id="secondary-header-logo" src="' + iusaThemeDirectoryURI + '/img/allianceFranchiseBrands.png" alt="Alliance Franchise Brands Logo">').insertAfter('#main-logo-anchor');

}